export function isDesktopViewport() {
  return window.innerWidth >= 1024;
}